/**
 * Utility functions for environment detection and configuration
 */

/**
 * Check if the application is running in development mode
 * This is a browser-safe implementation that doesn't rely on process.env
 */
export const isDevelopmentMode = (): boolean => {
  // Check if window exists (browser environment)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
  }
  return false;
};

/**
 * Get environment variables with fallbacks
 * @param key The environment variable key
 * @param defaultValue The default value if the environment variable is not defined
 */
export const getEnvVariable = (key: string, defaultValue: string = ''): string => {
  // Use window._env_ for runtime environment variables
  if (typeof window !== 'undefined' && (window as any)._env_ && (window as any)._env_[key]) {
    return (window as any)._env_[key];
  }
  
  // Fallback to process.env for build-time environment variables
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  
  return defaultValue;
};

/**
 * Firebase configuration with fallbacks
 */
export const getFirebaseConfig = () => {
  return {
    apiKey: getEnvVariable('REACT_APP_FIREBASE_API_KEY', 'AIzaSyDmbYJ-9l-Xw7rkrr1IcEUTdjdG2RZOPyc'),
    authDomain: getEnvVariable('REACT_APP_FIREBASE_AUTH_DOMAIN', 'fllboats.firebaseapp.com'),
    projectId: getEnvVariable('REACT_APP_FIREBASE_PROJECT_ID', 'fllboats'),
    storageBucket: getEnvVariable('REACT_APP_FIREBASE_STORAGE_BUCKET', 'fllboats.appspot.com'),
    messagingSenderId: getEnvVariable('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', '764800942701'),
    appId: getEnvVariable('REACT_APP_FIREBASE_APP_ID', '1:764800942701:web:6f72e49dc5f6a275d8b19e'),
  };
};

/**
 * Square API configuration with fallbacks
 */
export const getSquareConfig = (): {
  applicationId: string;
  locationId: string;
  accessToken: string;
  environment: 'sandbox' | 'production';
} => {
  return {
    applicationId: getEnvVariable('REACT_APP_SQUARE_APP_ID', 'sandbox-sq0idb-Yiqi9ruT2g9gYQ_JMF6Puw'),
    locationId: getEnvVariable('REACT_APP_SQUARE_LOCATION_ID', 'LBXN7HMJ3NX2S'),
    accessToken: getEnvVariable('REACT_APP_SQUARE_ACCESS_TOKEN', 'EAAAl4Ix3WRq6rEQV2zy4SBWBLz2LP1QIMwyMlBWH-0v2jt97ZTnbojQWP_WV-_1'),
    environment: getEnvVariable('REACT_APP_SQUARE_ENVIRONMENT', 'production') as 'sandbox' | 'production'
  };
}; 